<template>
  <ValidationProvider
    :rules="rules"
    :name="name"
    v-slot="{ errors }"
    mode="lazy"
    tag="span"
    class="idtr-field"
  >
    <input
      :id="id || null"
      :value="value"
      v-maska
      :data-maska="maskaAttr"
      :class="[
        'idtr-input',
        {
          'idtr-input--error': errors.length,
          'idtr-input--bold': bold,
          'idtr-input--inline': inline,
        },
      ]"
      :style="width ? { width } : null"
      :placeholder="placeholder"
      :maxlength="maxlength || null"
      spellcheck="false"
      autocomplete="off"
      @input="onInput"
    />
  </ValidationProvider>
</template>

<script>
import {vMaska} from "maska";
import {formatDateInput} from "@/assets/utils/date.input.mask";

export default {
  directives: {maska: vMaska},
  props: {
    id: {type: String, default: ""},
    value: {type: String, default: ""},
    name: {type: String, default: ""},
    rules: {type: [String, Object], default: ""},
    maska: {type: [String, Array], default: ""},
    digits: {type: Boolean, default: false},
    allow: {type: String, default: ""},
    // Smart date entry (see date.input.mask.js): "M/D/YYYY", "M/YYYY" or "M/D/YY, h:mm A"
    dateFormat: {type: String, default: ""},
    bold: {type: Boolean, default: false},
    inline: {type: Boolean, default: false},
    width: {type: String, default: ""},
    placeholder: {type: String, default: ""},
    maxlength: {type: Number, default: 0},
  },
  computed: {
    maskaAttr() {
      if (!this.maska || !this.maska.length) return undefined;
      return Array.isArray(this.maska)
        ? JSON.stringify(this.maska)
        : this.maska;
    },
  },
  methods: {
    onInput(event) {
      let next = event.target.value;
      if (this.dateFormat) {
        const typing = !/^delete/.test(event.inputType || "");
        next = formatDateInput(next, this.dateFormat, typing);
      }
      if (this.digits) next = next.replace(/\D/g, "");
      if (this.maxlength) next = next.slice(0, this.maxlength);
      if (this.allow) {
        next = next.replace(new RegExp("[^" + this.allow + "]", "g"), "");
      }
      if (next !== event.target.value) event.target.value = next;
      this.$emit("input", next);
    },
  },
};
</script>
